(function() {

    'use strict';

    angular.module('Services').service('ApiAccessClientListTableService', ApiAccessClientListTableService);

    ApiAccessClientListTableService.$inject = ['ClientService', 'TableLiteFactory'];

    function ApiAccessClientListTableService(ClientService, TableLiteFactory) {
        var tableStructure = {
            config: {
                noPagination: false,
                noHeaders: false,
                noItemsView: false,
                noTableFooter: false, //if set to true, whole footer including pagination and progessbar will be hidden
            },
            
            headers: [{
                label: 'URL', //header name
                viewName: 'url', //Attribute name on what to display from data
                filterName: 'url', //Attribute name on what to display from data
                filter: {
                    type: 'text',
                    class: 'bba-ref-no',
                    placeholder: 'Search',
                    onSubmit: function() {
                        console.log(this);
                    },
                    model: '' //optional
                    //text and inputDropdown uses `model` attribute for ng-model
                },
                headerFn: function() {} //Use for sorting
            }, {
                label: 'Company (PARENT)',
                viewName: 'company_parent',
                filterName: 'company_parent',
                filter: {
                    type: 'text',
                    class: 'bba-ref-no',
                    placeholder: 'Search',
                    onSubmit: function() {
                        console.log(this);
                    },
                    model: '' //optional
                    //text and inputDropdown uses `model` attribute for ng-model
                },
                headerFn: function() {}
            }, {
                label: 'Name of Contact',
                viewName: 'contact_person',
                filterName: 'contact_person',
                filter: {
                    type: 'text',
                    class: 'bba-ref-no',
                    placeholder: 'Search',
                    onSubmit: function() {
                        console.log(this);
                    },
                    model: '' //optional
                    //text and inputDropdown uses `model` attribute for ng-model
                },
                headerFn: function() {}
            }, {
                label: 'Permissions',
                viewName: 'permission',
                filterName: 'permission',
                filter: {
                    type: 'text',
                    class: 'bba-ref-no',
                    placeholder: 'Search',
                    onSubmit: function() {
                        console.log(this);
                    },
                    model: '' //optional
                    //text and inputDropdown uses `model` attribute for ng-model
                },
                headerFn: function() {}
            }],
            data: []
        };

        const tableActions = new TableLiteFactory(tableStructure,
            {
                serviceCallback: ClientService.Company.getAll,
                callbackFormat: ['success','error','filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters : {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            }
        );
        const sort = tableActions.sort;
        const evaluateFilter = tableActions.evaluateFilter;
        const sendRequest = tableActions.sendRequest;

        function buildTableData(data, pagination) {
            /*** START - Building of Data ***/
            tableActions.initializeTableData(data);
            angular.forEach(data.content, function(row, index) {
                
                row.company_parent = angular.getObjVal(row, 'company.name') || 'N/A';
                row.contact_person = angular.getObjVal(row,'company.contactPerson') || 'N/A';
                //row.permission = row.user.permissionGroup ? row.user.permissionGroup : 'N/A';
                row.url = 'N/A';
                row.permission = 'read';
                row.href = '/api-access/view/' + row.clientId;

                tableStructure.data.push(row);
            });
            /*** END - Building of Data ***/
        };
        return tableStructure
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/ApiAccessClientListTableService.js